const state = {
  username: localStorage.username,
  isauthorized: localStorage.isauthorized,
  bearertoken: localStorage.bearertoken,
  errordialog: false,
  errormessage: null,
  workingdialog: false
}

// getters
const getters = {
  username: state => {
    return state.username
  },
  isauthorized: state => {
    return state.isauthorized
  },
  bearertoken: state => {
    return state.bearertoken
  },
  errordialog: state => {
    return state.errordialog
  },
  errormessage: state => {
    return state.errormessage
  },
  workingdialog: state => {
    return state.workingdialog
  }
}

// actions
const actions = {
  initStorage ({ commit }) {
    commit('initStorage', null)
  },
  saveAuthorization ({ commit }, authinfo) {
    commit('saveAuthorization', authinfo)
  },
  deleteAuthorization ({ commit }) {
    commit('deleteAuthorization', null)
  },
  showError ({ commit }, errormessage) {
    commit('showError', errormessage)
  },
  clearError ({ commit }) {
    commit('clearError', null)
  },
  showWorkingStatus ({ commit }) {
    commit('showWorkingStatus', null)
  },
  clearWorkingStatus ({ commit }) {
    commit('clearWorkingStatus', null)
  }
}

// mutations
const mutations = {
  initStorage (state) {
    if (localStorage.username === 'undefined') {
      localStorage.username = state.username === undefined ? '' : state.username
    }
    if (localStorage.isauthorized === 'undefined') {
      localStorage.isauthorized = state.isauthorized === undefined ? '' : state.isauthorized
    }
    if (localStorage.bearertoken === 'undefined') {
      localStorage.bearertoken = state.bearertoken === undefined ? '' : state.bearertoken
    }
  },
  saveAuthorization (state, authinfo) {
    state.username = authinfo.username
    state.isauthorized = authinfo.isauthorized
    state.bearertoken = authinfo.bearertoken

    localStorage.username = authinfo.username
    localStorage.isauthorized = authinfo.isauthorized
    localStorage.bearertoken = authinfo.bearertoken
  },
  deleteAuthorization (state) {
    state.username = null
    state.isauthorized = null
    state.bearertoken = null

    delete localStorage.username
    delete localStorage.isauthorized
    delete localStorage.bearertoken
  },
  showError (state, errormessage) {
    state.errordialog = true
    state.errormessage = errormessage
  },
  clearError (state) {
    state.errordialog = false
    state.errormessage = null
  },
  showWorkingStatus (state) {
    state.workingdialog = true
  },
  clearWorkingStatus (state) {
    state.workingdialog = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/appcurrent.js